var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.token)?_c('login'):_c('frame',{style:({ backgroundColor: _vm.theme.pageBgColor })}),_c('pop-up')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }